// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond24Circle: FC<Diamond24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="m20.984 17.9-4.96 4.94-4.96-4.94h9.92ZM18.905 13.15l2.34 2.85H10.802l2.339-2.85h5.763Z" />
            <path
                d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm-3.756 11.25L7.52 17.045l8.503 8.455 8.504-8.455-4.724-5.795h-7.559ZM7 9.231l2.008 2.019 1.347-1.33L8.346 7.9 7 9.231Zm14.645.665 1.347 1.354L25 9.231l-1.347-1.353-2.008 2.018ZM15.08 6.5v2.85h1.89V6.5h-1.89Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Diamond24Circle;
